// Gamepad device, polled each frame. Standard mapping: left stick steers,
// face button (A/0) jumps, right stick nudges the camera, Start (9) pauses.

export class GamepadDevice {
  steer = 0;
  camNudge = { x: 0, y: 0 };
  jumpEdge = false;
  pauseEdge = false;
  active = false;

  private prevJump = false;
  private prevPause = false;

  poll(): void {
    const pads = navigator.getGamepads?.() ?? [];
    const pad = Array.from(pads).find((p): p is Gamepad => !!p);
    if (!pad) {
      this.active = false;
      this.steer = 0;
      return;
    }

    const lx = pad.axes[0] ?? 0;
    const rx = pad.axes[2] ?? 0;
    const ry = pad.axes[3] ?? 0;

    this.steer = lx;
    this.camNudge.x += rx * 0.05;
    this.camNudge.y += ry * 0.05;

    const jump = pad.buttons[0]?.pressed ?? false;
    const pause = (pad.buttons[9]?.pressed ?? false) || (pad.buttons[8]?.pressed ?? false);
    if (jump && !this.prevJump) this.jumpEdge = true;
    if (pause && !this.prevPause) this.pauseEdge = true;
    this.prevJump = jump;
    this.prevPause = pause;

    this.active = Math.abs(lx) > 0.2 || jump || Math.abs(rx) > 0.2;
  }
}
